import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('quantity-input', () => import(/* webpackMode: "lazy" */'./quantity-input'));
